export function useSlider(countSlides: number) {
  return {
    nextSlide: (curIndex: number) => {
      if (countSlides > curIndex + 1) {
        curIndex++;
      } else {
        curIndex = 0;
      }

      return curIndex;
    },
    prevSlide: (curIndex: number) => {
      if (curIndex === 0) {
        curIndex = countSlides - 1;
      } else {
        curIndex--;
      }

      return curIndex;
    },
  };
}
